/*
 * NOTE: We want to maintain this component level template as .ts file so we can add comments.
 */

export default {
  name: 'dashify:Bar',
  title: 'Bar',
  owner: 'System',
  solution: '',
  tags: ['data', 'visualization', 'bar'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'Nov 08, 2023, 02:12 PM',
  spec: {
    props: {
      // Props directly from Highcharts API
      highchartsConfig: {},
      // custom props to implement some user functionality that requires multiple Highcharts prop settings
      customConfig: {
        useDashForNoData: false,
      },
    },
    defaults: {
      series: [],
      chart: {
        type: 'bar',
        style: {
          fontFamily: 'var(--typography-font-body)',
        },
        styledMode: false,
      },
      colors: [
        'var(--color-accent-a)',
        'var(--color-accent-b)',
        'var(--color-accent-c)',
        'var(--color-accent-d)',
        'var(--color-accent-e)',
        'var(--color-accent-f)',
        'var(--color-accent-g)',
        'var(--color-accent-h)',
        'var(--color-accent-i)',
        'var(--color-accent-j)',
      ],
      xAxis: {
        title: '',
        type: 'category',
        dateTimeLabelFormats: {
          month: '%e. %b',
          year: '%b',
        },
        labels: {
          style: {
            fontFamily: 'var(--typography-font-body)',
            fontSize: '11px',
            fontStyle: 'normal',
            fontWeight: '400',
            color: 'var(--color-default-text-medium)',
            backgroundColor: 'var(--color-default-bg)',
          },
        },
      },
      yAxis: {
        title: '',
        min: 0,
        labels: {
          style: {
            fontFamily: 'var(--typography-font-body)',
            fontSize: '11px',
            fontStyle: 'normal',
            fontWeight: '400',
            color: 'var(--color-default-text-medium)',
            backgroundColor: 'var(--color-default-bg)',
          },
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          borderWidth: 0,
        },
      },
      tooltip: {
        valueDecimals: 0,
        useHTML: true,
        outside: true,
        backgroundColor: 'var(--color-default-bg)',
        style: {
          fontFamily: 'var(--typography-font-body)',
          fontSize: '11px',
          fontStyle: 'normal',
          fontWeight: '400',
          color: 'var(--color-default-text)',
          backgroundColor: 'var(--color-default-bg)',
        },
      },
      legend: {
        enabled: false,
      },
      lang: {
        noData: 'No Data',
      },
    },
    view: [
      [
        'dashify:If',
        { condition: '/${ $count(props.highchartsConfig.series.data) > 0 }' },
        [
          ['dashify:Then', {}, [['dashify:Highcharts', '/${ $defaultsDeep({}, props.highchartsConfig, defaults) }']]],
          [
            'dashify:Else',
            {},
            [
              [
                'dashify:If',
                { condition: '/${ props.customConfig.useDashForNoData }' },
                [
                  ['dashify:Then', {}, [['p', { className: 'w-[140px]' }, '—']]],
                  ['dashify:Else', {}, [['dashify:EmptyBox']]],
                ],
              ],
            ],
          ],
        ],
      ],
    ],
  },
};
